import React from 'react';
import { prettyKey } from '../hooks/useEinsteinChat';

// "See full page" — built server-side (services/einsteinRouter.js's buildQuickStatSourceRoute for
// quick_stat, resolveEntryParams/buildRouteUrl for compose elements), not guessed client-side.
// Absent (sourceRoute/route: null) only in defensive edge cases documented at the call sites;
// simply omits the link rather than rendering a broken one. Extracted out of EinsteinMessage.js
// (2026-09-10) so EinsteinComposePanels.js can use it too without an EinsteinMessage.js <->
// EinsteinComposePanels.js circular import (EinsteinMessage.js imports panel rendering FROM that
// file).
export function SeeFullPageLink({ sourceRoute, sourceKey, goToRoute, accent }) {
  if (!sourceRoute) return null;
  return (
    <button type="button" onClick={() => goToRoute(sourceRoute)}
      style={{ border: 'none', background: 'transparent', color: accent, fontSize: 12.5, fontWeight: 600, cursor: 'pointer', padding: 0, marginTop: 2, textAlign: 'left' }}>
      See full {prettyKey(sourceKey)} page →
    </button>
  );
}
